import React from "react";
import Box from "@mui/material/Box";
import { Grid, Pagination, LinearProgress, Paper, Alert } from "@mui/material";
import { useConfig } from "../../context/ConfigContext";
import styles from "./home.module.css";
import TopFilters from "../../components/Filters/TopFilters";
import GenericExpandablePanel, {
	Position,
} from "../../components/GenericExpandablePanel";
import FilterPanel from "../../components/Filters/FilterPanel";
import OutsideAlerter from "../../components/NavBar/OutsideAlerter";
import { PanelId, usePanelContext } from "../../context/PanelContext";
import DatePanel from "../../components/Filters/DatePanel";
import DocumentLayout from "../../components/DocumentLayout";
import useDynamicFilters from "./useDynamicFilters";
import { useDocuments } from "../../context/DocumentContext";
import { grayscaleBg } from "../../styles/theme";
import CardViewModal from "../../components/CardViewModal";

export interface UniqueFilters {
	filterBar: Set<string>;
	filterPanel: Set<string>;
}

export default function Home() {
	const {
		categories,
		numericLabels,
		loadingCategories: loadingConfig,
		filters: allFilters,
		startDate,
		endDate,
	} = useConfig();
	const { documents, page, setPage, totalPages, loading } = useDocuments();
	const { expandedPanel, setExpandedPanel } = usePanelContext();
	const { barFilters, panelFilters } = useDynamicFilters(allFilters);

	const handlePageChange = (
		event: React.ChangeEvent<unknown>,
		value: number
	) => {
		setPage(value);
	};

	return (
		<>
			{Boolean(loadingConfig) ? (
				<Box>
					<LinearProgress />
				</Box>
			) : (
				<Box className={styles.main_container}>
					<Box flex={1}>
						<Box className={styles.filter_header}>
							<TopFilters
								filters={barFilters}
								dateRange={{ start: startDate, end: endDate }}
							/>
						</Box>
						{expandedPanel === PanelId.Filter && (
							<OutsideAlerter
								onOutsideClick={() => setExpandedPanel(null)}
								excludedElementId={PanelId.Filter}
							>
								<GenericExpandablePanel position={Position.Left}>
									<FilterPanel filters={panelFilters} />
								</GenericExpandablePanel>
							</OutsideAlerter>
						)}
						{expandedPanel === PanelId.Date && (
							<OutsideAlerter
								onOutsideClick={() => setExpandedPanel(null)}
								excludedElementId={PanelId.Date}
							>
								<GenericExpandablePanel>
									<DatePanel />
								</GenericExpandablePanel>
							</OutsideAlerter>
						)}

						{Boolean(loading) && (
							<Box>
								<LinearProgress />
							</Box>
						)}
						{!loading && Boolean(!documents?.length) ? (
							<Alert severity="info">No documents found</Alert>
						) : (
							<Box className={styles.grid_container}>
								<DocumentLayout
									documents={documents}
									isLoading={loading}
									categories={categories}
									numericLabels={numericLabels}
								/>
							</Box>
						)}
						{totalPages > 1 && (
							<Box className={styles.pagination_container}>
								<Grid item xs={10} display="flex" justifyContent="center">
									<Paper
										className={styles.pagination_paper}
										sx={{ backgroundColor: grayscaleBg, borderRadius: 0 }}
										elevation={2}
									>
										<Pagination
											count={totalPages}
											page={page}
											size="small"
											onChange={handlePageChange}
										/>
									</Paper>
								</Grid>
							</Box>
						)}
					</Box>
					<CardViewModal />
				</Box>
			)}
		</>
	);
}
